export const getDesignTokens = (mode) => ({

	palette: {
		mode,
		...(mode === 'light'
			? {
				background: '#FFFFFF',
				blue: '#4890FC',
				border: '1px solid #F6F7F9',
				fourth: '#B9C2CF',
				green: '#49B073',
				lineHover: 'linear-gradient(90deg, #F6F7F9 0%, rgba(255, 255, 255, 0) 76.87%)',
				primary: {
					main: '#4890FC'
				},
				red: '#FF6370',
				second: '#F6F7F9',
				text: {
					primary: '#131635',
					secondary: '#7C8DA7'
				},
				third: '#e1e2e6'
			}
			: {
				background: '#101011',
				blue: '#4422EF',
				border: '1px solid #28282D',
				fourth: '#3D414F',
				green: '#30985B',
				lineHover: 'linear-gradient(90deg, #28282D 0%, #101011 27.92%)',
				primary: {
					main: '#4422EF'
				},
				red: '#DD4041',
				second: '#28282D',
				text: {
					primary: '#FFFFFF',
					secondary: '#6B6F77'
				},
				third: '#2F323C'
			}
		)
	},
	// eslint-disable-next-line
	breakpoints: {
		values: {
			xs: 0,
			// eslint-disable-next-line
			sm: 576,
			// eslint-disable-next-line
			md: 768,
			// eslint-disable-next-line
			lg: 992,
			xl: 1200,
			xxl: 1400,
			xxxl: 1600
		}
	},
	typography: {
		body1: {
			fontSize: '0.75rem',
			fontWeight: 500,
			lineHeight: '1rem',
			// eslint-disable-next-line sort-keys
			'@media (max-width:768px)': {
				fontSize: '0.688rem',
				lineHeight: '0.875rem'
			},
			// eslint-disable-next-line sort-keys
			'@media (max-width:576px)': {
				fontSize: '0.625rem',
				lineHeight: '0.75rem'
			}

		},
		fontFamily: ['SF Pro Display', 'sans-serif'].join(','),
		fontSize: 12,
		fontWeight: 500,
		fontWeightLight: 400,
		fontWeightRegular: 500,
		lineHeight: 16,
		px13: {
			fontFamily: ['SF Pro Display', 'sans-serif'].join(','),
			fontSize: '0.813rem',
			fontWeight: 700,
			lineHeight: '1.5rem',
			// eslint-disable-next-line sort-keys
			'@media (max-width:768px)': {
				fontSize: '0.75rem',
				lineHeight: '1.375rem'
			},
			// eslint-disable-next-line sort-keys
			'@media (max-width:576px)': {
				fontSize: '0.688rem',
				lineHeight: '1.25rem'
			}
		},
		px14: {
			fontFamily: ['SF Pro Display', 'sans-serif'].join(','),
			fontSize: '0.875rem',
			fontWeight: 500,
			lineHeight: '1.25rem',
			// eslint-disable-next-line sort-keys
			'@media (max-width:768px)': {
				fontSize: '0.813rem',
				lineHeight: '1.125rem'
			},
			// eslint-disable-next-line sort-keys
			'@media (max-width:576px)': {
				fontSize: '0.75rem',
				lineHeight: '1rem'
			}
		},
		px16: {
			fontFamily: ['SF Pro Display', 'sans-serif'].join(','),
			fontSize: '1rem',
			fontWeight: 600,
			lineHeight: '1.875rem',
			// eslint-disable-next-line sort-keys
			'@media (max-width:768px)': {
				fontSize: '0.938rem',
				lineHeight: '1.75rem'
			},
			// eslint-disable-next-line sort-keys
			'@media (max-width:576px)': {
				fontSize: '0.875rem',
				lineHeight: '1.625rem'
			}
		},
		px18: {
			fontFamily: ['SF Pro Display', 'sans-serif'].join(','),
			fontSize: '1.125rem',
			fontWeight: 600,
			lineHeight: '2rem',
			// eslint-disable-next-line sort-keys
			'@media (max-width:768px)': {
				fontSize: '1.063rem',
				lineHeight: '1.875rem'
			},
			// eslint-disable-next-line sort-keys
			'@media (max-width:576px)': {
				fontSize: '1rem',
				lineHeight: '1.75rem'
			}
		},
		px20: {
			fontFamily: ['SF Pro Display', 'sans-serif'].join(','),
			fontSize: '1.25rem',
			fontWeight: 500,
			lineHeight: '2rem',
			// eslint-disable-next-line sort-keys
			'@media (max-width:768px)': {
				fontSize: '1.125rem',
				lineHeight: '1.875rem'
			},
			// eslint-disable-next-line sort-keys
			'@media (max-width:576px)': {
				fontSize: '1rem',
				lineHeight: '1.75rem'
			}

		}
	}
})
